const globalInfo = {
  state: {
    utm_source: null,
  },

  mutations: {
    SET_UTM_SOURCE(state, payload) {
      console.log('SET_UTM_SOURCE', payload);
      state.utm_source = payload;
    },
  },

  actions: {},
};

export default globalInfo;
